import React from 'react'
import PropTypes from 'prop-types'

const VIP_STYLE = {
    color: '#f1c40f',
}


const RatingComponent = ({ total, score }) => {
    const list = []
    for (let index = 1; index <= total; index++) {
        list.push({
            className: (score >= index) ? 'fa fa-star' : 'fa fa-star-o',
        })
    }

    return (
        <div>
            {list.map((entry, index) => {
                return (<i key={index} className={entry.className} style={VIP_STYLE}/>)
            })}
        </div>
    )
}


RatingComponent.propTypes = {
    total: PropTypes.number.isRequired,
    score: PropTypes.number.isRequired,
}

export default RatingComponent



// WEBPACK FOOTER //
// ./src/modules/form/component/RatingComponent.js